import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { contact } from '../../data/site';
import { Button } from '../ui/Button';
export function MobileActionBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-afb-line bg-white/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-169" data-mp="1gty2wla0qm9k">
      <div className="grid grid-cols-[auto_1fr] gap-3" data-id="element-170" data-mp="172agiysbjvey">
        <Button href={contact.phoneHref} variant="outline-light" size="md" ariaLabel={`Call ${contact.phoneDisplay}`} data-id="element-171" data-mp="16zo8yz5fhfwq">
          <PhoneIcon aria-hidden="true" className="h-4 w-4" data-id="element-172" data-mp="y13uka6whseb" />
          Call
        </Button>
        <Button href="#contact" size="md" data-id="element-173" data-mp="y3glhcumzd3i">
          Request a demo
        </Button>
      </div>
    </div>;
}